export var IconConstants = {
  ARROW: "fa-kit fa-arrow",
  ARROW_CIRCLE_DOWN: "fa-kit fa-arrowcircledown",
  ARROW_DOWN: "fa-light fa-arrow-down",
  ARROW_LEFT: "fa-light fa-arrow-left",
  ARROW_RIGHT: "fa-light fa-arrow-right",
  ARROW_UP: "fa-light fa-arrow-up",
  ARROWS_IN_SIMPLE: "fa-kit fa-arrowsinsimple",
  ARROWS_OUT_SIMPLE: "fa-kit fa-arrowsoutsimple",
  BRIEFCASE_SIMPLE: "fa-kit fa-briefcasesimple",
  BUILDINGS_TWO: "fa-kit fa-buildings-two",
  CALENDAR: "fa-kit fa-calendar",
  CHAT_CIRCLE: "fa-kit fa-chatcircle",
  CHECK: "fa-kit fa-check",
  CHECKS: "fa-kit fa-checks",
  CHECK_SQUARE: "fa-kit fa-checksquare",
  CHEVRON_DOWN: "fa-light fa-chevron-down",
  CHEVRON_LEFT: "fa-light fa-chevron-left",
  CHEVRON_RIGHT: "fa-light fa-chevron-right",
  CHEVRON_UP: "fa-light fa-chevron-up",
  CIRCLE: "fa-solid fa-circle",
  CIRCLE_CHECK: "fa-solid fa-circle-check",
  CIRCLE_THREE_PLUS: "fa-kit fa-circlesthreeplus",
  CITY: "fal fa-city",
  DEVICE_MOBILE: "fa-kit fa-devicemobile",
  DOTS_SIX: "far fa-grip-dots-vertical",
  EDIT: "far fa-edit",
  ELLIPSIS: "fa-light fa-ellipsis",
  ENVELOPE: "fa-kit fa-envelope",
  EYE: "fa-kit fa-eye",
  EYE_SLASH: "fa-light fa-eye-slash",
  EXCLAMATION_TRIANGLE: "fa-light fa-exclamation-triangle",
  FILE: "fa-kit fa-file",
  FILE_ARROW_DOWN: "fa-kit fa-filearrowdown",
  FILE_ARROW_UP: "fa-kit fa-filearrowup",
  FILE_TEXT: "fa-kit fa-filetext",
  FILTER: "fal fa-sliders-simple",
  FLOOR_PLAN: "fa-kit fa-floorplan",
  FOLDER_OPEN: "fa-kit fa-folderopen",
  GEAR: "fa-kit fa-gear",
  GRIP_LINES: "far fa-grip-lines",
  GRID: "fa-sharp fa-light fa-grid-2",
  IMAGE: "fa-kit fa-image",
  INFO_CIRCLE: "fa-light fa-circle-info",
  LIGHTNING: "fa-light fa-bolt",
  LINK: "fa-kit fa-link",
  LOCATION_DOT: "fa-light fa-location-dot",
  MAP: "fa-light fa-map",
  MAP_PIN: "fa-kit fa-mappin",
  MAGNIFYING_GLASS: "fa-light fa-magnifying-glass",
  MINUS: "fa-light fa-minus",
  PAPER_PLANE_RIGHT: "fa-kit fa-paperplaneright",
  PDF: "fa-kit fa-pdf",
  PENCIL: "fa-kit fa-pencil",
  PHOTO: "far fa-camera",
  PLAY: "fal fa-play",
  PLUS: "fa-kit fa-plus",
  PHONE: "fal fa-phone",
  CLOCKCLOCKWISE: "fa-kit fa-clockclockwise",
  SHARE: "fa-kit fa-share",
  SIGNIN: "fa-kit fa-signin",
  SORT_DOWN: "fa-kit fa-sortdescending",
  SORT_UP: "fa-kit fa-sortascending",
  SPINNER: "fa fa-pulse fa-spinner",
  TABLE: "fa-light fa-table",
  THUMBS_DOWN: "fa-kit fa-thumbsdown",
  THUMBS_DOWN_ACTIVE_OLD: "fa-solid fa-thumbs-down",
  THUMBS_DOWN_OLD: "fa-light fa-thumbs-down",
  THUMBS_UP: "fa-kit fa-thumbsup",
  THUMBS_UP_ACTIVE_OLD: "fa-solid fa-thumbs-up",
  THUMBS_UP_OLD: "fa-light fa-thumbs-up",
  TRASH: "fa-kit fa-trash",
  UPLOAD: "fa-kit fa-upload",
  UPLOAD_SIMPLE: "fa-light fa-arrow-up-from-bracket",
  USER: "fa-kit fa-user",
  X: "fal fa-xmark"
};